<template>
    <div class="flex">
        <div class="  ">
            <div v-for="tab in tabs" :key="tab.name" @click="selectTab(tab)"
            class="p-3 cursor-pointer rounded"
                :class="{ active: tab.name === selectedTab }">
                {{ tab.label }}
            </div>
        </div>
        <div class="flex-1 py-3 pl-5">
            <slot :name="selectedTab"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

interface Tab {
    name: string;
    label: string;
}

const props = defineProps<{
    initialTab?: string;
    tabs: Tab[];
    tabFontSize?: string;
    px?: string;
    borderBottomWidth?: string;
    tabMarginRight?: string
}>();

const selectedTab = ref(props.initialTab || (props.tabs.length ? props.tabs[0].name : ''));

const selectTab = (tab: Tab) => {
    selectedTab.value = tab.name;
};

// Watch for changes in initialTab prop and update selectedTab accordingly
watch(() => props.initialTab, (newVal) => {
    if (newVal && props.tabs.find(tab => tab.name === newVal)) {
        selectedTab.value = newVal;
    }
});
</script>

<style scoped>
.active {
    background-color: #f2f2f2;
}
</style>